import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { text } from '../text';
import { components } from '../components';

interface TermType {
  id: number;
  title?: string;
  description?: string;
  points?: string[];
  bottom?: string;
}

const termsAndConditions: TermType[] = [
  {
    id: 0,
    // title: 'NestFin – Terms & Conditions',
    description:
      'These Terms govern your use of the NestFin app and services provided by NestFin Technologies Pvt. Ltd. By using the app, you agree to follow these Terms.',
  },
  {
    id: 1,
    title: '1. Use of the Platform',
    description:
      'NestFin provides a platform to search, compare, and book PG and rental accommodations. NestFin is not a property owner; all property details, availability, pricing, and rules are managed by the respective PG owners/operators.',
  },
  {
    id: 2,
    title: '2. User Responsibilities',
    description:"You agree to:",
    points: [
      '- Provide accurate information during registration and booking.',
      '- Verify property details before booking or moving in.',
      '- Communicate responsibly with PG owners/operators.',
    ],
    bottom:
      'NestFin is not responsible for disputes or inaccuracies in property listings.',
  },
  {
    id: 3,
    title: '3. Bookings & Payments',
    points: [
      '- Bookings are confirmed only after approval by the PG owner/operator.',
      '- Payment terms and rental policies vary by property.',
      '- Sensitive payment details (UPI PIN, card numbers) are not stored by NestFin.',
    ],
  },
  {
    id: 4,
    title: '4. Cancellation & Refund Policy',
    points: [
      '- If a tenant cancels within 24 hours of the booking date, the token amount is refunded after deducting NestFin platform fee, payment gateway charges, and taxes.',
      '- If the PG Owner/Operator cancels or denies the room after confirming the booking, the full token amount will be refunded after deducting platform fee, payment gateway charges, and taxes.',
      '- Refund processing time depends on banking and payment gateway partners.',
    ],
  },
  {
    id: 5,
    title: '5. Limitation of Liability',
    description:"NestFin is not liable for:",
    points: [
      '- Disputes between tenants and PG owners.',
      '- Inaccurate or misleading property information.',
      '- Losses or damages arising from rental agreements.',
      '- Platform downtime or technical errors.',
    ],
    bottom: 'The app is provided “as is” without warranties.',
  },
  {
    id: 6,
    title: '6. Changes to Terms',
    description:
      'NestFin may update these Terms at any time. Continued use of the app indicates acceptance of the updated Terms.',
  },
  {
    id: 7,
    title: '7. Contact Us',
    description:"NestFin Technologies Pvt. Ltd.",
    points: ['Email: hello@nestfin.app', 'Website: https://nestfin.app'],
  },
];

export const TermsAndConditions: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
  }, [pathname]);

  const renderHeader = (): JSX.Element => {
    return <components.Header title="Terms & Conditions" goBack={true} />;
  };

  const renderContent = (): JSX.Element => {
    return (
      <main className="container" style={{ paddingBottom: 0 }}>
        <div style={{ marginTop: '10%', marginBottom: 20 }}>
          {termsAndConditions.map((item) => (
            <div key={item.id} style={{ marginBottom: '10%' }}>
              <text.H5 style={{ marginBottom: 10 }}>{item.title}</text.H5>
              {item.description && <text.T14>{item.description}</text.T14>}

              <div>
                {item.points?.map((point, index) => {
                  const lower = point.toLowerCase();

                  if (lower.includes('email')) {
                    const parts = point.split('Email:');
                    const email = parts[1]?.trim();
                    return (
                      <text.T14 key={index}>
                        Email: &nbsp;
                        {email ? (
                          <a href={`mailto:${email}`} style={{ color: '#007bff' }}>
                            {email}
                          </a>
                        ) : (
                          point
                        )}
                      </text.T14>
                    );
                  } else if (lower.includes('website')) {
                    const parts = point.split('Website:');
                    const url = parts[1]?.trim();
                    return (
                      <text.T14 key={index}>
                        Website: &nbsp;
                        {url ? (
                          <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#007bff' }}
                          >
                            {url}
                          </a>
                        ) : (
                          point
                        )}
                      </text.T14>
                    );
                  } else {
                    return <text.T14 key={index}>{point}</text.T14>;
                  }
                })}
              </div>

              {item.bottom && (
                <text.T14 style={{ marginTop: '10px' }}>{item.bottom}</text.T14>
              )}
            </div>
          ))}
        </div>
      </main>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};


// import React, { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { components } from '../components';

// const termsAndConditions = [
//     {
//         id: 1,
//         title: '1. Acceptance of Terms',
//         content:
//             'By accessing and using our PG booking platform, you agree to comply with and be bound by these Terms and Conditions. If you do not agree with any part of the terms, you must not use our services.',
//     },
//     {
//         id: 2,
//         title: '2. Services Provided',
//         content:
//             'We provide a platform for users to search, compare, and book Paying Guest (PG) accommodations. We are not property owners but facilitate communication and transactions between tenants and PG owners.',
//     },
//     {
//         id: 3,
//         title: '3. User Responsibilities',
//         content:
//             'You agree to provide accurate information during registration and bookings. You are solely responsible for interactions with PG owners and verifying property details before making any commitments.',
//     },
//     {
//         id: 4,
//         title: '4. Booking and Payments',
//         content:
//             'All bookings are subject to availability and confirmation by the PG owner. Payment terms may vary per property and are governed by the agreements between tenants and PG providers.',
//     },
// {
//     id: 5,
//     title: '5. Cancellation and Refunds',
//     content:
//         'If the tenant requests to cancel the booking before the move-in date, the token amount will be refunded after deducting the applicable platform fee and taxes.',
// },
//     {
//         id: 6,
//         title: '6. Limitation of Liability',
//         content:
//             'We are not liable for any damages, losses, or disputes that arise from interactions or transactions between users and PG owners. We do not guarantee the accuracy or availability of listings.',
//     },
//     {
//         id: 7,
//         title: '7. Modifications to Terms',
//         content:
//             'We reserve the right to modify these Terms and Conditions at any time. Any changes will be effective immediately upon posting on the platform. Continued use of our services constitutes acceptance of those changes.',
//     },
//     {
//         id: 8,
//         title: '8. Termination',
//         content:
//             'We reserve the right to suspend or terminate your access to the platform if you violate these terms or engage in fraudulent or harmful behavior.',
//     },
//     {
//         id: 9,
//         title: '9. Contact Information',
//         content:
//             'For any questions or concerns regarding these Terms and Conditions, please contact us at support@nestfin.app.',
//     },
// ];

// export const TermsAndConditions: React.FC = () => {
//     const { pathname } = useLocation();

//     useEffect(() => {
//         window.scrollTo(0, 0);
//         document.documentElement.scrollTop = 0;
//     }, [pathname]);

//     const renderHeader = (): JSX.Element => {
//         return <components.Header title="Terms & Conditions" goBack={true} />;
//     };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main className="container" style={{ paddingBottom: 0 }}>
//                 <div style={{ marginTop: '10%', marginBottom: 20 }}>
//                     {termsAndConditions.map((item) => (
//                         <div key={item.id} style={{ marginBottom: '10%' }}>
//                             <text.H5 style={{ marginBottom: 10 }}>{item.title}</text.H5>
//                             <text.T14>{item.content}</text.T14>
//                         </div>
//                     ))}
//                 </div>
//             </main>
//         );
//     };

//     return (
//         <>
//             {renderHeader()}
//             {renderContent()}
//         </>
//     );
// };
